module.exports = __webpack_public_path__ + "img/thumbnail_BorneanOrangutan_f_normal.46f6654d.png";